import React, { useState, useRef } from "react";
import {
    IonPage,
    IonContent,
    IonButton,
    IonText,
} from "@ionic/react";
import { Swiper, SwiperSlide } from "swiper/react";
import { Pagination } from "swiper/modules";

import "swiper/css";
import "swiper/css/pagination";
import "./Onboarding.css";

const Onboarding: React.FC<{ onFinish: () => void; asDialog?: boolean }> = ({
    onFinish,
    asDialog = false,
}) => {
    const isUpdatesRoute = window.location.pathname.startsWith("/updates");
    const [activeIndex, setActiveIndex] = useState(0);
    const swiperRef = useRef<any>(null);

    if (isUpdatesRoute) {
        return null;
    }

    const slides = [
        {
            title: "AI Chat",
            desc: "Meet your Bacolod travel buddy! Ask anything about the City of Smiles — from where to enjoy authentic chicken inasal, relax at cafés, explore attractions, nightlife, and more.",
            img: "assets/tutorial/chat_bacolod.png",
        },
        {
            title: "Navigate",
            desc: "Find your way around with optimized routes powered by Google Maps and AI. Discover which jeepney to ride within Bacolod, or get smart, AI-guided navigation plans for trips beyond the city.",
            img: "assets/tutorial/navigate_bacolod.png",
        },
        {
            title: "Emergency",
            desc: "When it matters most, help is closer than you think. Find hospitals, police stations, vets, pharmacies and more near you, then call or get directions with one tap.",
            img: "assets/tutorial/emergency_bacolod.png",
        },
        {
            title: "Contribute",
            desc: "Share what’s new in Bacolod! Add routes, fare updates, improve existing responses, or even promote local spots. Every contribution helps make Bacolod City AI Guide smarter and more helpful.",
            img: "assets/tutorial/contribute_bacolod.png",
        },
    ];

    const carousel = (
        <Swiper
            modules={[Pagination]}
            pagination={{ clickable: true }}
            onSwiper={(swiper: any) => (swiperRef.current = swiper)}
            onSlideChange={(swiper: any) => setActiveIndex(swiper.activeIndex)}
        >
            {slides.map((slide, index) => (
                <SwiperSlide key={index}>
                    <div className="slide">
                        <img className="slide-img" src={slide.img} alt={slide.title} />
                        <IonText>
                            <h2>{slide.title}</h2>
                            <p>{slide.desc}</p>
                        </IonText>
                        {/* Show "Swipe to continue →" only on first three slides */}
                        {(index === 0 || index === 1 || index === 2) && (
                            <p
                                className="swipe-hint"
                                onClick={() => swiperRef.current?.slideNext()}
                            >
                                Swipe to continue →
                            </p>
                        )}
                        {/* Show button only on the last slide */}
                        {index === slides.length - 1 && (
                            <IonButton
                                expand="block"
                                className="get-started-btn"
                                onClick={onFinish}
                            >
                                Get Started
                            </IonButton>
                        )}
                    </div>
                </SwiperSlide>
            ))}
        </Swiper>
    );

    // 💻 Web: a centered dialog the user can dismiss anytime (X or backdrop).
    if (asDialog) {
        return (
            <div className="ob-backdrop" onClick={onFinish}>
                <div
                    className="ob-dialog onboarding--dialog"
                    onClick={(e) => e.stopPropagation()}
                >
                    <button
                        className="ob-close"
                        onClick={onFinish}
                        aria-label="Close"
                    >
                        ×
                    </button>
                    <div className="onboarding-content onboarding-content--dialog">
                        {carousel}
                    </div>
                </div>
            </div>
        );
    }

    // 📱 Native: fullscreen page.
    return (
        <IonPage>
            <IonContent fullscreen className="onboarding-content">
                {carousel}
            </IonContent>
        </IonPage>
    );
};

export default Onboarding;
